import {ScrollView, View} from 'react-native';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootHeatmapScreenProps} from '../../Typings/NavigationTypes';
import getStyles from '../ADAPT-MH/ADAPT-MH.styles';

type Props = RootHeatmapScreenProps;

const Heatmap: React.FC<Props> = () => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.card}>
          <Text weight="bold" fontSize={20}>
            Heatmap export
          </Text>
          <Text>
            Interactive screening and results are available on the web. Heatmap PDF export remains
            available in the Android and iOS apps.
          </Text>
        </View>
      </ScrollView>
    </PageContainer>
  );
};

export default Heatmap;
